<template>
  <section class="item-center flex flex-col justify-center py-10 lg:px-[24.5%] lg:py-20">
    <section class="flex flex-col items-center gap-y-3">
      <h2 class="text-2xl lg:text-3xl">FAQ</h2>
      <div class="h-[1px] w-[50px] bg-gold1" />
    </section>
    <article class="px-4 py-10">
      <p class="text-md break-words pb-3 font-semibold">
        {{ enFaq.question }}
      </p>
      <div class="answer-richtext" v-html="enFaq.answer" />
    </article>
    <section class="flex w-full flex-col gap-y-4 self-center px-4 lg:w-[400px]">
      <AtomsPrimaryButton class="h-[48px] w-full" :on-click="onClickReturnToFAQ">Return to FAQ</AtomsPrimaryButton>
      <AtomsSecondaryButton class="h-[48px] w-full" :disabled="false" :on-click="onClickContactUs">
        <span>Contact us</span>
      </AtomsSecondaryButton>
    </section>
  </section>
</template>

<script lang="ts" setup>
import { useBuildUrl } from '@/composables/utils/useBuildUrl';
import { useMicroCMSDetailParams } from '@/composables/utils/useMicroCMSDetailParams';
import { formatHtmlForDescriptionTag } from '@/utils/stringUtils';
import { useLastModifiedHeader } from '@/wabunka-src/common/composables/general/useLastModifiedHeader/useLastModifiedHeader';
import { COMMON_TITLE } from '@/wabunka-src/constants/metaTag';
import { useEnFaq } from '@/wabunka-src/features/FAQ/composables/useEnFaq';

const { hasDraftKey } = useMicroCMSDetailParams();
const { enFaq, hasSucceeded } = await useEnFaq();
useLastModifiedHeader(enFaq.value.revisedAt);
const route = useRoute();
const { buildUrlWithEndSlash } = useBuildUrl();

const onClickReturnToFAQ = () => {
  navigateTo('/faq/', { external: true });
};

const onClickContactUs = () => {
  navigateTo('/contact/', { external: true });
};

const isNoIndex = enFaq.value.category.includes('表示しない') || !hasSucceeded.value || hasDraftKey.value;
const link = [{ rel: 'canonical' as const, href: buildUrlWithEndSlash(route.path) }];

const TITLE = `${enFaq.value.question} | ${COMMON_TITLE}`;
useServerSeoMeta({
  title: TITLE,
  description: formatHtmlForDescriptionTag(enFaq.value.answer),
  ogTitle: TITLE,
  ogDescription: formatHtmlForDescriptionTag(enFaq.value.answer),
});

if (isNoIndex) useRobotsRule('noindex, nofollow');

useHead({
  link: isNoIndex ? undefined : link,
});
</script>

<style lang="scss">
// リッチテキストで渡ってきたhtmlに対して当てるスタイル
.answer-richtext {
  p {
    color: #423d36;
    word-break: break-word;
  }
  figure {
    padding-top: 15px;
    padding-bottom: 15px;
    display: flex;
    justify-content: center;

    img {
      max-width: 100%;
      height: auto;
    }
  }
  a {
    color: #423d36;
    text-decoration: underline;
  }
}
</style>
